<template>
  <div>
    <!-- Loading -->
    <Loading v-if="loading" class="p-8" />

    <!-- Form -->
    <form v-else @submit.prevent="submitFeedback" class="relative flex flex-col max-w-2xl min-h-screen mx-auto bg-white shadow">
      <!-- Header -->
      <div class="flex items-center justify-between bg-white border-b">
        <router-link :to="{ name: 'TrackingLinkStatus', params: { trackingCode: $route.params.trackingCode } }" class="flex items-center justify-center px-4 font-medium text-accent hover:underline" v-submitting="submitting">
          Cancel
        </router-link>
        <div class="p-4 font-medium leading-none text-center">
          Feedback
        </div>
        <button class="px-4 font-medium text-accent hover:underline" v-submitting="submitting" :disabled="form.stars === 0">
          Submit
        </button>
      </div>

      <!-- Inputs -->
      <template v-if="submitted || order.feedback_stars || order.feedback_text"> 
        <div class="p-8">
          <div class="px-4 py-16 text-center text-gray-500 bg-gray-100 border rounded">
            <fa :icon="['far', 'thumbs-up']" size="2x" class="text-gray-400" />
            <div class="mt-4">Thank you for your feedback!</div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="flex justify-center px-4 pt-4 text-gray-500">
          Rate your experience with {{ account.name }}
        </div>
        <div class="flex justify-center px-4 py-2 text-4xl">
          <star-rating 
            v-model="form.stars"
            :increment="0.5"
            :show-rating="false"
            :star-size="40"
            inactive-color="#CBD5E0"
            active-color="#ffd43b"
            :border-width="0" />
        </div>
        <div class="p-4">
          <textarea ref="feedback" cols="30" rows="6" class="w-full form-textarea" v-model="form.text" placeholder="Do you have any feedback? (Optional)">
          </textarea>
        </div>
      </template>
    </form>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'

export default {
  name: 'Feedback',

  metaInfo: {
    title: 'Give Feedback'
  },

  components: {
    StarRating
  },

  created () {
    this.fetchStatus()
  },

  data () {
    return {
      loading: true,
      submitting: false,
      submitted: false,
      order: {},
      account: {},
      form: {
        stars: 0,
        text: ''
      }
    }
  },

  methods: {
    async fetchStatus () {
      try {
        const { data } = await this.$api.get(`tracking-links/${this.$route.params.trackingCode}/status`)

        if (data.order.feedback_stars) {
          this.$router.push({ 
            name: 'TrackingLinkStatus', 
            params: { 
              trackingCode: this.$route.params.trackingCode 
            }
          })
        }

        this.loading = false
        this.order = data.order
        this.account = data.order.account
        setTimeout(() => {
          if (this.$refs.feedback) {
            this.$refs.feedback.focus()
          }
        }, 50)
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message || error)
      }
    },

    async submitFeedback () {
      try {
        this.submitting = true
        await this.$api.post(`tracking-links/${this.$route.params.trackingCode}/feedback`, this.form)
        this.submitted = true
        this.$toasted.show('Feedback submitted.')
        this.$router.push({ name: 'TrackingLinkStatus', params: { trackingCode: this.$route.params.trackingCode }})
      } catch (error) {
        if (response.status === 403) {
          this.$router.push({ 
            name: 'TrackingLinkStatus', 
            params: { 
              trackingCode: this.$route.params.trackingCode 
            } 
          })
        }  
        
        if (error.response.message) {
          this.$toasted.error(error.response.message)
        } else {
          throw Error(error)
        }
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>